// light-gallery.service.ts
import { Injectable } from '@angular/core';
import { LightGallerySettings } from "lightgallery/lg-settings";
import { LightGallery } from "lightgallery/lightgallery";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import lgAutoplay from "lightgallery/plugins/autoplay";
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LightGalleryService {
  private lightGalleryInstance: LightGallery | undefined;

    setLightGalleryInstance(instance: LightGallery) {
    this.lightGalleryInstance = instance;
  }

  getLightGalleryInstance() {
    return this.lightGalleryInstance;
  }

  // Add more methods for other LightGallery events as needed
}
